/**
 * @graphql agg
 */
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ConfluencePricingEndOfTrialPremiumToStandardQuery: GraphQLTaggedNode = graphql`
	query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					... on CcpEntitlement {
						experienceCapabilities {
							changeOfferingV2(skipTrial: true, offeringName: "standard") {
								isAvailableToUser
								experienceUrl
							}
						}
						standardPrice: defaultOfferingTransitions(offeringName: "Standard") {
							listPriceForOrderWithDefaults {
								averageAmountPerUnit
								item {
									chargeElement
								}
							}
						}
						subscription {
							trial {
								listPriceEstimates {
									averageAmountPerUnit
									item {
										chargeElement
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
